import {useQuery} from '@tanstack/react-query';

import {useScenarioEmissions} from '../hooks/scenarioEmissionHooks';
import {CurrentScenarioId, TargetScenarioId} from './fctCalculator.types';

type Input = {
  currentScenario?: CurrentScenarioId;
  targetScenario?: TargetScenarioId;
};

type Output = {
  currentEmissions: number | null; // tCO2e
  targetEmissions: number | null; // tCO2e
};
export function useFctCalculator(input: Input) {
  const {
    data: currentData,
    isLoading: currentLoading,
    error: currentError,
  } = useScenarioEmissions(input.currentScenario);
  const {data: targetData, isLoading: targetLoading, error: targetError} = useScenarioEmissions(input.targetScenario);

  return useQuery({
    queryKey: ['useFctCalculator', input],
    enabled: !currentLoading && !targetLoading,
    queryFn: () => {
      if (currentError) {
        if (currentError instanceof Error) {
          throw currentError;
        } else {
          throw new Error('Error fetching current emissions: ' + currentError);
        }
      }
      if (targetError) {
        if (targetError instanceof Error) {
          throw targetError;
        } else {
          throw new Error('Error fetching target emissions: ' + targetError);
        }
      }

      const output: Output = {
        currentEmissions: currentData || null,
        targetEmissions: targetData || null,
      };

      return output;
    },
  });
}
